var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("stock")))]),
      _vm.hasStockModule
        ? _c(
            "w-list",
            [
              _c(
                "w-list-item",
                [
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(_vm.$ct("overwrite-stock"))),
                  ]),
                  _c(
                    "w-list-item-action",
                    [
                      _vm.overwriteStockRunning
                        ? _c("w-progress-circular", { attrs: { small: "" } })
                        : _c(
                            "w-button",
                            {
                              attrs: {
                                icon: "",
                                disabled: !_vm.hasNewerBookYear,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.overwriteStock()
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "play" } })],
                            1
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-list-item",
                [
                  _c("w-list-item-text", [
                    _vm._v(
                      _vm._s(_vm.$ct("copy-backorder-sales-to-new-bookyear"))
                    ),
                  ]),
                  _c(
                    "w-list-item-action",
                    [
                      _vm.copyBackorderSalesRunning
                        ? _c("w-progress-circular", { attrs: { small: "" } })
                        : _c(
                            "w-button",
                            {
                              attrs: {
                                icon: "",
                                disabled: !_vm.canCopyBackorderSales,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.copyBackorderSales()
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "play" } })],
                            1
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-list-item",
                [
                  _c("w-list-item-text", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$ct("compute-stock")) + " "),
                      _c("span", { staticClass: "last-executed-date" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getLastExecutedText(
                              _vm.currentBookYearObj.LastComputeStock
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "w-list-item-action",
                    [
                      _vm.recalculateStockRunning
                        ? _c("w-progress-circular", { attrs: { small: "" } })
                        : _c(
                            "w-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.computeStock()
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "play" } })],
                            1
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-list-item",
                [
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(_vm.$ct("empty-stock"))),
                  ]),
                  _c(
                    "w-list-item-action",
                    [
                      _vm.emptyingStockRunnig
                        ? _c("w-progress-circular", { attrs: { small: "" } })
                        : _c(
                            "w-button",
                            {
                              attrs: {
                                icon: "",
                                disabled: _vm.emptyStockDisabled,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.emptyStock()
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "play" } })],
                            1
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-list-item",
                [
                  _c("w-list-item-text", [
                    _vm._v(
                      _vm._s(
                        _vm.$ct("show-negative-amounts-on-inventory-report")
                      )
                    ),
                  ]),
                  _c(
                    "w-list-item-action",
                    [
                      _c("w-switch", {
                        attrs: {
                          value: _vm.isShowNegativeAmountsOnInventoryReport,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.toggleShowNegativeAmountsOnInventoryReport(
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-list-item",
                [
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(_vm.$ct("out-of-stock-select-group"))),
                  ]),
                  _c(
                    "w-list-item-action",
                    [
                      _c("w-switch", {
                        attrs: {
                          value: _vm.isOutOfStockSelectedSupplierSelectGroup,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.toggleOutOfStockSelectedSupplierSelectGroup(
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-list-item",
                [
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(_vm.$ct("show-info-field-on-stock-in"))),
                  ]),
                  _c(
                    "w-list-item-action",
                    [
                      _c("w-switch", {
                        attrs: { value: _vm.isShowInfoFieldOnStockIn },
                        on: {
                          input: function ($event) {
                            return _vm.toggleShowInfoFieldOnStockIn($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "w-card-content",
            [_c("app-missing-module", { attrs: { "module-id": _vm.module } })],
            1
          ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.accountingStockEmptyModalOpen,
            callback: function ($$v) {
              _vm.accountingStockEmptyModalOpen = $$v
            },
            expression: "accountingStockEmptyModalOpen",
          },
        },
        [
          _vm.accountingStockEmptyModalOpen
            ? _c("app-accounting-stock-empty-modal", {
                on: {
                  close: function ($event) {
                    _vm.accountingStockEmptyModalOpen = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.accountingStockRecomputeModalOpen,
            callback: function ($$v) {
              _vm.accountingStockRecomputeModalOpen = $$v
            },
            expression: "accountingStockRecomputeModalOpen",
          },
        },
        [
          _vm.accountingStockRecomputeModalOpen
            ? _c("app-accounting-stock-recompute-modal", {
                on: {
                  close: function ($event) {
                    _vm.accountingStockRecomputeModalOpen = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }